import { lazy } from "react";

export const AccountSettings = lazy(() =>
  import("pages/accountSettings/AccountSettings")
);
